import React from "react";
import "./src/styles/style.css";

export const wrapRootElement = ({ element }) => <>{element}</>;
